import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CategoryState } from "src/types/category.types";

const initialState: CategoryState = {
  createCategory: {
    loading: false,
    data: null,
    error: null,
  },
  editCategory: {
    loading: false,
    data: null,
    error: null,
  },
  categoryList: {
    loading: false,
    data: null,
    error: null,
  },
};

const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    // create category actions
    createCategoryRequest: (state, action: PayloadAction<any>) => {
      state.createCategory.loading = true;
      state.createCategory.data = null;
      state.createCategory.error = null;
    },
    createCategorySuccess: (state, action: PayloadAction<any>) => {
      state.createCategory.loading = false;
      state.createCategory.data = action.payload;
      state.createCategory.error = null;
    },
    createCategoryError: (state, action: PayloadAction<string>) => {
      state.createCategory.loading = false;
      state.createCategory.data = null;
      state.createCategory.error = action.payload;
    },
    resetCreateCategory: (state) => {
      state.createCategory = { loading: false, data: null, error: null };
    },

    // edit category actions
    editCategoryRequest: (state, action: PayloadAction<any>) => {
      state.editCategory.loading = true;
      state.editCategory.data = null;
      state.editCategory.error = null;
    },
    editCategorySuccess: (state, action: PayloadAction<any>) => {
      state.editCategory.loading = false;
      state.editCategory.data = action.payload;
      state.editCategory.error = null;
    },
    editCategoryError: (state, action: PayloadAction<string>) => {
      state.editCategory.loading = false;
      state.editCategory.data = null;
      state.editCategory.error = action.payload;
    },
    resetEditCategory: (state) => {
      state.editCategory = { loading: false, data: null, error: null };
    },

    // get category list
    getCategoryListRequest: (
      state,
      action: PayloadAction<{ page: number; limit: number }>
    ) => {
      state.categoryList.loading = true;
      state.categoryList.data = null;
      state.categoryList.error = null;
    },
    getCategoryListSuccess: (state, action: PayloadAction<any>) => {
      state.categoryList.loading = false;
      state.categoryList.data = action.payload;
      state.categoryList.error = null;
    },
    getCategoryListError: (state, action: PayloadAction<string>) => {
      state.categoryList.loading = false;
      state.categoryList.data = null;
      state.categoryList.error = action.payload;
    },
    resetCategoryList: (state) => {
      state.categoryList = { loading: false, data: null, error: null };
    },
  },
});

export const {
  createCategoryRequest,
  createCategorySuccess,
  createCategoryError,
  resetCreateCategory,

  editCategoryRequest,
  editCategorySuccess,
  editCategoryError,
  resetEditCategory,

  getCategoryListRequest,
  getCategoryListSuccess,
  getCategoryListError,
  resetCategoryList,
} = categorySlice.actions;

export default categorySlice.reducer;
